import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { AvailableLanguages, getLocizeLanguages } from '../i18n'

export const useLanguages = () => {
    const { i18n } = useTranslation()
    const [langs, setLangs] = useState<AvailableLanguages>()

    useEffect(() => {
        if (!i18n) return
        getLocizeLanguages().then(languages => {
            if (languages) {
                setLangs(languages)
                }
            }).catch(error => {
                console.error('Error fetching languages:', error)
            })
    }, [])

    const { resolvedLanguage, language } = i18n
    const userLang = { ...langs?.[resolvedLanguage ?? 0], language, resolvedLanguage }

    return { langs, userLang }
}
